import React from 'react'
import styles from './DataTableRow.module.scss'

interface DataTableRowProps {
  children: React.ReactNode
  className?: never
}

export const DataTableRow: React.FC<DataTableRowProps> = ({ children }) => (
  <tr className={styles.row}>{children}</tr>
)
